import React from 'react'
import styled from 'styled-components'
import { Box } from '@machobear/design-system'
import { breakpoints, fontWeights, colors } from '@/styles'
import StatusBadge from '@/components/status-badge'
import Skeleton from '@/components/skeleton'

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 12px;
  @media (max-width: ${breakpoints.tabletLandscape}) {
    margin: 0 12px 24px 12px;
  }
`

const Title = styled.p`
  font-weight: ${fontWeights.medium};
  font-size: 16px;
  line-height: 28px;
  color: ${colors.grey16};
  margin: 0;
`

export type StatusType = 'poor' | 'average' | 'very_good' | 'excellent'

type BTableTitleProps = {
  title?: string
  showStatus?: boolean
  statusText?: string
  statusType?: StatusType
  isLocked?: boolean
  isLoading?: boolean
  icon?: React.ReactNode
}

const TableTitle: React.FC<BTableTitleProps> = ({
  title = '',
  showStatus = false,
  statusText = '',
  statusType,
  isLocked = false,
  isLoading = false,
  icon
}) => {
  const type = statusType ?? 'default'
  return (
    <TitleContainer>
      <Box display="flex" alignItems="center" gap="xxsmall">
        {title && <Title>{title}</Title>}
        {icon}
      </Box>
      {showStatus &&
        (isLoading ? (
          <Skeleton width={75} height={25} />
        ) : (
          <StatusBadge title={statusText} type={type} size="small" isLocked={isLocked} />
        ))}
    </TitleContainer>
  )
}

export default TableTitle
